import { STORY_SCENES, STORY_TIMELINE, StoryScene } from './story';

export function getStoryCaption(scene: StoryScene, elapsed: number, reducedMotion: boolean) {
  if (scene === StoryScene.APP) {
    const time = reducedMotion ? STORY_TIMELINE.prototype.durationMs : elapsed;
    if (time < STORY_TIMELINE.prototype.caption.sketchUntilMs) {
      return 'Sketch an idea. Build the interface and logic together in OXIDE.';
    }
    if (time < STORY_TIMELINE.prototype.caption.downloadUntilMs) {
      return 'Your user downloads the Container onto their device. Your app is ready to load.';
    }
    if (time < STORY_TIMELINE.prototype.caption.runtimeUntilMs) {
      return 'The Runtime Engine starts, then loads your app into the Container.';
    }
    return 'Your app is running on their device—and keeps working offline.';
  }

  if (scene === StoryScene.CONNECTED) {
    const time = reducedMotion ? STORY_SCENES[StoryScene.CONNECTED].durationMs : elapsed;
    if (time < STORY_TIMELINE.connected.caption.syncUntilMs) {
      return 'The inspection syncs from the device to the App Backend.';
    }
    if (time < STORY_TIMELINE.connected.caption.taskUntilMs) {
      return 'Build a CloudCode task in OXIDE to turn that inspection into action.';
    }
    return 'One connected workflow: sync the inspection, run the task, deliver a report, and update your systems.';
  }

  return STORY_SCENES[scene].caption;
}
